// 需要 jquery
if (!customElements.get("scroll-featured-collection")) {
    customElements.define(
      "scroll-featured-collection",
      class ScrollFeaturedCollection extends HTMLElement {
        constructor(){
          super();
          this.sectionId = $(this).attr('data-sectionId');
          this.desktopShowNum = $(this).attr('data-desktopShowNum');
          this.mobileShowNum = $(this).attr('data-mobileShowNum');
          this.rowGap = $(this).attr('data-rowGap');
          this.sfcSwiper = $(this).find(`.swiper-${this.sectionId}`);
          this.initScrollFeaturedCollection();
        }

        initScrollFeaturedCollection(){
          const that = this;

          setTimeout(function(){
            let windowWidth = $(window).width();
            let rowGap = Number(that.rowGap);
            let mobileShowNum = Number(that.mobileShowNum);
            let desktopShowNum = Number(that.desktopShowNum);
  
            that.sfcSwiper.slick({
              slidesToShow: desktopShowNum,
              slidesToScroll: 1,
              autoplay: false,
              arrows: true,
              rows:0,
              responsive:[
                {
                  breakpoint: 768,
                  settings: {
                    autoplay: false,
                    slidesToShow: mobileShowNum,
                    slidesToScroll: mobileShowNum
                  }
                }
              ]
            });
          },0)
          
          
        }
      }
    )
}